'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _containers = require('containers');

var _InputParameters = require('./InputParameters.css');

var _InputParameters2 = _interopRequireDefault(_InputParameters);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// would be nice if this component used enterprise simple table

var InputParameters = function (_Component) {
  (0, _inherits3.default)(InputParameters, _Component);

  function InputParameters(props) {
    (0, _classCallCheck3.default)(this, InputParameters);
    return (0, _possibleConstructorReturn3.default)(this, (InputParameters.__proto__ || (0, _getPrototypeOf2.default)(InputParameters)).call(this, props));
  }

  (0, _createClass3.default)(InputParameters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inputs = _props.inputs,
          createInput = _props.createInput;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: _InputParameters2.default.line },
          _react2.default.createElement(
            _components.EnterpriseButton,
            {
              size: 'MEDIUM',
              type: 'PRIMARY',
              onClick: createInput
            },
            'Add'
          )
        ),
        inputs.map(function (id) {
          return _react2.default.createElement(
            'div',
            { key: id, className: _InputParameters2.default.line },
            _react2.default.createElement(_containers.InputNameEditor, { id: id }),
            _react2.default.createElement(_containers.InputValueEditor, { id: id }),
            _react2.default.createElement(_containers.DeleteInput, { id: id })
          );
        })
      );
    }
  }]);
  return InputParameters;
}(_react.Component);

exports.default = InputParameters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/InputParameters/InputParameters.jsx
// module id = 1456
// module chunks = 0